<assistants-empty-state
  *ngIf="assistants?.length === 0 && displayContext?.searchCompleted && emptyState"
  class="assistants-empty-state"
></assistants-empty-state>
<div class="assistants-container" *ngIf="!emptyState">
  <div *ngIf="assistants()?.length === 0 && displayContext?.searchCompleted" class="no-results">
    <h1 class="no-results-title headline-1">{{ assistantContent.noResults }}</h1>
    <q class="headline-1 bold" *ngIf="query">
      {{ query | truncate: 30 }}
    </q>
  </div>
  <div class="assistants-header page-limit wide">
    <div class="assistants-header-subtitle">
      <span class="subtitle-text">{{ assistantContent.assistantSubtitle }}</span>
      <u-button style="display: inline-block" type="link" [label]="assistantContent.learnMore" (onClick)="navigateToLearnMore()"></u-button>
    </div>
    <results-filters-box
      id="filters"
      [filters]="filters"
      [enableClearAll]="true"
      (filterChange)="onFilterChange($event)"
      (clearAll)="clearAllFilters()"
      [separateLayout]="true"
    ></results-filters-box>
  </div>

  <div class="scrollbar-wrapper" #contextContainer>
    <ng-scrollbar #mainScroll *ngIf="assistants()?.length > 0" visibility="hover">
      <div scrollViewport infiniteScroll [scrollWindow]="false">
        <div class="page-limit wide">
          <div
            class="grid"
            [ngClass]="{
              'assistants-items-list': layoutMode === 'list',
              'grid-cards': layoutMode === 'gallery',
            }"
          >
            <ng-container *ngIf="loaded; else loading">
              <ng-container *ngFor="let assistant of displayAssistants(); let i = index; trackBy: trackByAssistant">
                <ng-container [ngSwitch]="assistant.type">
                  <ng-container *ngSwitchCase="'assistant'">
                    <assistant-item
                      #assistantItem
                      class="result-item"
                      [attr.data-index]="i"
                      [assistantItem]="assistant"
                      [viewMode]="layoutMode"
                      [selected]="i === selectedIndex"
                      (click)="updateSelectedIndex(i)"
                      (contextOpen)="updateSelectedIndex(i)"
                    >
                    </assistant-item>
                  </ng-container>
                  <ng-container *ngSwitchCase="'header'">
                    <result-header
                      [ngClass]="{ 'results-footer': assistant.isFooter, 'results-header': !assistant.isFooter }"
                      [model]="assistant"
                      [selected]="i === selectedIndex && assistant.isFooter"
                      (focusGroupClick)="resultHeaderClick(assistant.group?.name)"
                    ></result-header>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <gradient-overflow *ngIf="!isLauncher"></gradient-overflow>
    </ng-scrollbar>
  </div>
</div>
